import React, { useCallback } from 'react';
import './ColorTag.css';

const ColorTag = ({title, clickMe, isActive=false}) => {  

  const handleClickMe = useCallback(()=>{
    clickMe(title);
  },[clickMe, title]);

  const style = `colorTag ${isActive ? 'tagActive' : ''}`

  return (
    <div className={style} onClick={handleClickMe}>
      {title}
    </div>
  );
};

export default ColorTag;